import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from 'src/app/_services/account.service';

@Component({
  selector: 'app-modal-pasajero-eliminado',
  templateUrl: './modal-pasajero-eliminado.component.html',
  styleUrls: ['./modal-pasajero-eliminado.component.css']
})
export class ModalPasajeroEliminadoComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,    
    private accountService: AccountService
  ) { }

  ngOnInit(): void {
  }

  closeModal(){
    //this.router.navigate(['/admin/tours-agencias-reservados']);
    this.activeModal.dismiss('Cross click');
  }

}
